import Image from 'next/image';
import Link from 'next/link';
import SubHeading from '@/components/SubHeading';
import { agcFooterLinks as footerLinks, socialMediaList } from '@/constants/footer';
import googlePlayIcon from '@/images/google-play-logo.png';
export interface FooterProps {
  heading: string;
  content: Content[];
}
interface Content {
  label: string;
  link: string;
  isInternal?: boolean;
}
interface StatsDataItem {
  id: number;
  value: string;
  name: string;
}
interface StatsData {
  image_url: string;
  data: StatsDataItem[];
}
export interface FooterData {
  static_strip: StatsData;
}
interface Props {
  containerClassname?: string;
}
const FooterList = ({
  heading,
  content
}: FooterProps) => {
  return <div className="px-4 py-5" data-sentry-component="FooterList" data-sentry-source-file="AgcFooter.tsx">
      <div className="flex mb-5">
        <div className={`bg-[#008582] rounded w-1 mr-4`} />
        <SubHeading data-sentry-element="SubHeading" data-sentry-source-file="AgcFooter.tsx">{heading}</SubHeading>
      </div>
      <div className="flex flex-col gap-4 px-5">
        {content.map((item, index) => {
        return item.link !== '' ? <Link href={item.link} key={index} className="text-white text-sm" target={`${item.isInternal ? '' : '_blank'}`}>
              {item.label}
            </Link> : null;
      })}
      </div>
    </div>;
};
const Footer = ({
  containerClassname = ''
}: Props) => {
  return <footer data-sentry-component="Footer" data-sentry-source-file="AgcFooter.tsx">
      <div className={`text-white pb-20 m-auto w-full md:flex md:justify-between md:flex-wrap bg-[#008582] ${containerClassname}`}>
        {footerLinks.map((items, index) => <FooterList key={index} {...items} />)}
        <div className="px-4 py-5">
          <SubHeading className="mb-5 px-5" data-sentry-element="SubHeading" data-sentry-source-file="AgcFooter.tsx">Contact Us</SubHeading>
          <div className="px-5">
            <div>
              <p className="text-sm">Call us on:</p>
              <a href={`tel:18001036110`} className="inline-block bg-white text-primary-100 rounded-lg px-8 py-2 font-nato-semibold mt-2">
                1800 1036 110
              </a>
            </div>
          </div>
        </div>
        <div className="px-4 py-5">
          <SubHeading className="mb-5 px-5" data-sentry-element="SubHeading" data-sentry-source-file="AgcFooter.tsx">
            Experience AgriCentral app on mobile
          </SubHeading>
          <Link href="https://play.google.com/store/apps/details?id=com.globalagricentral" className="flex px-5" aria-label="agricentral google play store" target="_blank" rel="noopener noreferrer" data-sentry-element="Link" data-sentry-source-file="AgcFooter.tsx">
            <Image src={googlePlayIcon} alt="google play store" data-sentry-element="Image" data-sentry-source-file="AgcFooter.tsx" />
          </Link>
        </div>
        <div className="flex flex-col px-4 py-5 gap-5">
          <div className="flex">
            <div className={`bg-[#008582] rounded w-1 mr-4`} />
            <SubHeading data-sentry-element="SubHeading" data-sentry-source-file="AgcFooter.tsx">Follow us on</SubHeading>
          </div>
          <div className="px-5">
            <div className="flex gap-4 items-center">
              {socialMediaList.map((item, index) => {
              return item.link !== '' ? <Link href={item.link} key={index} className="text-white text-sm cursor-pointer" target="_blank">
                    <Image src={item.image} alt={item.alt} width={32} height={32} />
                  </Link> : null;
            })}
            </div>
            <SubHeading className="mt-4" data-sentry-element="SubHeading" data-sentry-source-file="AgcFooter.tsx">
              <Link href="mailto:contact@agrevolution.in" className="hover:underline" data-sentry-element="Link" data-sentry-source-file="AgcFooter.tsx">
                Contact@agrevolution.in
              </Link>
            </SubHeading>
          </div>
          <div className="text-sm text-white border-t-2 border-solid border-gray-30 pt-5 px-5">
            Copyright @DeHaat {new Date().getFullYear()}
          </div>
          <div className="text-sm text-white px-5">All rights reserved</div>
        </div>
      </div>
    </footer>;
};
export default Footer;